(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-sort]')) return;
    var url = new URL(location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');
    location.href = url.toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mobile menu toggle. Runs once per page; works with any number of header instances.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-menu-toggle]');
    if (!button) return;
    var menu = document.getElementById(button.getAttribute('aria-controls'));
    var open = !menu.classList.contains('open');
    menu.classList.toggle('open', open);
    button.setAttribute('aria-expanded', String(open));
    button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var PAUSE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>';
    var PLAY = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initHero(hero) {
      if (hero.dataset.ready) return;
      hero.dataset.ready = '1';
      var section = hero.parentElement;
      var slides = hero.querySelectorAll('[data-slide]');
      var tabs = section.querySelectorAll('[data-hero-go]');
      var pauseBtn = section.querySelector('[data-hero-pause]');
      var DUR = +hero.dataset.duration || 7000;
      var cur = 0, timer = null, paused = reduce, hold = false;
      if (slides.length < 2) return;

      function show(i) {
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (el, j) {
          el.classList.toggle('on', j === cur);
          if (j === cur) el.removeAttribute('inert'); else el.setAttribute('inert', '');
        });
        tabs.forEach(function (t, j) {
          t.classList.remove('on');
          t.removeAttribute('aria-current');
          if (j === cur) {
            void t.offsetWidth; // restart the progress-bar transition
            t.classList.add('on');
            t.setAttribute('aria-current', 'true');
          }
          t.classList.toggle('hold', paused || hold);
        });
        clearTimeout(timer);
        if (!paused && !hold) timer = setTimeout(function () { show(cur + 1); }, DUR);
      }
      function setPaused(p) {
        paused = p;
        pauseBtn.innerHTML = p ? PLAY : PAUSE;
        pauseBtn.setAttribute('aria-label', p ? 'Play rotating banners' : 'Pause rotating banners');
        show(cur);
      }
      function setHold(h) {
        hold = h;
        if (h) {
          clearTimeout(timer);
          tabs.forEach(function (t) { t.classList.add('hold'); });
        } else show(cur);
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () { show(+t.dataset.heroGo); });
      });
      pauseBtn.addEventListener('click', function () { setPaused(!paused); });
      hero.addEventListener('mouseenter', function () { setHold(true); });
      hero.addEventListener('mouseleave', function () { setHold(false); });
      hero.addEventListener('focusin', function () { setHold(true); });
      hero.addEventListener('focusout', function (e) { if (!hero.contains(e.relatedTarget)) setHold(false); });
      var tx = null;
      hero.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (tx === null) return;
        var dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) > 50) show(cur + (dx < 0 ? 1 : -1));
        tx = null;
      });

      // Theme editor: jump to the slide being edited and stop rotating.
      section.addEventListener('shopify:block:select', function (e) {
        var i = Array.prototype.indexOf.call(slides, e.target);
        if (i !== -1) { hold = true; show(i); }
      });
      section.addEventListener('shopify:block:deselect', function () { setHold(false); });

      setPaused(paused);
    }

    function initAll(root) { (root || document).querySelectorAll('[data-hero]').forEach(initHero); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  // Pages pasted from elsewhere often start with their own <h1> repeating the title; hide the repeat.
  document.querySelectorAll('.page-wrap').forEach(function (wrap) {
    var title = wrap.querySelector('.phead h1');
    var dup = wrap.querySelector('.rte h1');
    if (!title || !dup) return;
    var norm = function (s) { return s.replace(/[^a-z0-9]/gi, '').toLowerCase(); };
    if (norm(title.firstChild.textContent || '') === norm(dup.textContent)) dup.hidden = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pouch-sizes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var S = window.SweetShop;
      // pouch.js loads first in theme.liquid; if it somehow hasn't yet, try again once the page has loaded.
      if (!S) return window.addEventListener('load', function () { init(root); }, { once: true });
      root.querySelectorAll('[data-sizes]').forEach(function (sec) {
        if (sec.dataset.ready) return;
        sec.dataset.ready = '1';
        var row = sec.querySelector('.scale-row');
        var cards = Array.prototype.slice.call(row.querySelectorAll('.sz'));
        cards.forEach(function (el) {
          var info = S.packageInfo(el.dataset.title, { limit: el.dataset.limit, lb: el.dataset.lb, type: el.dataset.type, handle: el.dataset.handle });
          el.dataset.type = info.type;
          el.dataset.lb = info.lb;
          el.querySelector('[data-sz-limit]').textContent = info.limit + ' sweets';
          el.querySelector('.sz-art').setAttribute('data-pouch', JSON.stringify({
            fill: 0.7, seed: +el.dataset.seed, lb: info.lb, aria: S.cleanTitle(el.dataset.title),
            shape: S.shapeFor(info.type, el.dataset.title)
          }));
        });
        // Light → heavy so the row reads like a size chart.
        cards.sort(function (a, b) { return a.dataset.lb - b.dataset.lb; }).forEach(function (el) { row.appendChild(el); });

        // Tabs listed in the "Hide these tabs" setting (e.g. Halloween) are left out, with their products.
        var hidden = (sec.dataset.hideTypes || '').split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
        cards = cards.filter(function (el) {
          if (hidden.indexOf(el.dataset.type.toLowerCase()) === -1) return true;
          el.remove();
          return false;
        });
        var types = S.TYPE_ORDER.filter(function (t) {
          return cards.some(function (el) { return el.dataset.type === t; });
        });
        cards.forEach(function (el) {
          if (types.indexOf(el.dataset.type) === -1) types.push(el.dataset.type);
        });
        var tabs = sec.querySelector('[data-type-tabs]');
        function select(t) {
          tabs.querySelectorAll('.ptab').forEach(function (x) {
            x.classList.toggle('on', x.dataset.t === t);
            x.setAttribute('aria-pressed', String(x.dataset.t === t));
          });
          cards.forEach(function (el) { el.hidden = el.dataset.type !== t; });
          row.scrollLeft = 0;
        }
        if (types.length > 1) {
          tabs.innerHTML = types.map(function (t) {
            return '<button type="button" class="ptab" data-t="' + S.esc(t) + '">' + S.esc(t) + '</button>';
          }).join('');
          tabs.addEventListener('click', function (e) {
            var b = e.target.closest('.ptab');
            if (b) select(b.dataset.t);
          });
          select(types[0]);
        } else {
          tabs.hidden = true;
        }
        S.hydratePouches(sec);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-checkout"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-upsell]');
    if (!root) return;
    function mark(btn) {
      btn.textContent = 'In your bag ✓';
      btn.classList.add('added');
      btn.disabled = true;
    }
    // Items already in the bag (e.g. Skip the Line chosen in the builder) aren't offered again.
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inBag = {};
        cart.items.forEach(function (i) { inBag[i.variant_id] = true; });
        root.querySelectorAll('[data-upsell-add]').forEach(function (b) {
          if (inBag[b.getAttribute('data-upsell-add')]) mark(b);
        });
      })
      .catch(function () {});
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-upsell-add]');
      if (!b || !window.SweetBag) return;
      b.disabled = true;
      b.textContent = 'Adding…';
      window.SweetBag.add([{ id: +b.getAttribute('data-upsell-add'), quantity: 1 }], { silent: true })
        .then(function () { mark(b); })
        .catch(function () { b.disabled = false; b.textContent = 'Add'; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function init(root) {
      // Gallery thumbnails swap the main photo.
      root.querySelectorAll('.pdp-thumb').forEach(function (b) {
        b.addEventListener('click', function () {
          var main = root.querySelector('[data-pdp-main]');
          if (!main) return;
          main.removeAttribute('srcset');
          main.src = b.dataset.src;
          root.querySelectorAll('.pdp-thumb').forEach(function (x) { x.classList.toggle('on', x === b); });
        });
      });
      // Quantity steppers.
      root.querySelectorAll('.pdp-buy [data-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var input = b.parentElement.querySelector('input');
          input.value = Math.max(1, (+input.value || 1) + +b.dataset.qty);
        });
      });
      // Add to bag through the bottom sheet instead of leaving the page.
      root.querySelectorAll('[data-product-form]').forEach(function (form) {
        form.addEventListener('submit', function (e) {
          if (!window.SweetBag) return;
          e.preventDefault();
          var data = new FormData(form);
          window.SweetBag.add([{ id: +data.get('id'), quantity: +data.get('quantity') || 1 }]).catch(function () {});
        });
      });
      // Package facts from metafields or the product title ("Choose up to 10 Sweets", "1 1/2 LB").
      root.querySelectorAll('[data-package-facts]').forEach(function (ul) {
        if (!window.SweetShop) return;
        var info = window.SweetShop.packageInfo(ul.dataset.title, { limit: ul.dataset.limit, lb: ul.dataset.lb, handle: ul.dataset.handle });
        ul.querySelector('[data-fact-limit]').textContent = 'Pick up to ' + info.limit + ' sweets';
        if (/lb/i.test(ul.dataset.title) || ul.dataset.lb) {
          var lb = ul.querySelector('[data-fact-lb]');
          lb.textContent = window.SweetShop.formatLb(info.lb) + ' LB of candy';
          lb.hidden = false;
        }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
